import React from 'react'

import { CONFIG } from '../../config'

import * as styles from './styles.module.scss'

const BlogHeader = ({ title, heroImage, backgroundColour: { hex } }) => (
  <div style={{ background: `${hex}` }}>
    <div className={styles.Container}>
      <nav role="navigation" className={styles.Navigation}>
        <a href={`${CONFIG.BLOG_URL}`}>&lt; Back to Blog</a>
      </nav>
      <div className={styles.Content}>
        <div className={styles.Image}>
          <img src={heroImage.file.url} alt="" />
        </div>
        <div className={styles.Title}>
          <h1>{title}</h1>
        </div>
      </div>
    </div>
  </div>
)

export default BlogHeader
